import { render, staticRenderFns } from "./GameContainer.vue?vue&type=template&id=6355c965&"
import script from "./GameContainer.vue?vue&type=script&lang=js&"
export * from "./GameContainer.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/jquery.qtip.min.css?vue&type=style&index=0&lang=css&"
import style1 from "@/assets/css/jquery-ui.structure.min.css?vue&type=style&index=1&lang=css&"
import style2 from "@/assets/css/jquery.mCustomScrollbar.min.css?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\soiko\\Documents\\Projects\\game\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6355c965')) {
      api.createRecord('6355c965', component.options)
    } else {
      api.reload('6355c965', component.options)
    }
    module.hot.accept("./GameContainer.vue?vue&type=template&id=6355c965&", function () {
      api.rerender('6355c965', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/GameContainer.vue"
export default component.exports